import styled from "styled-components";

export const Content = styled.div`
  position: relative;
  min-height: 400px;
  height: 100%;
  width: 100%;
`;